<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item ">
    <h1>რა არის ლიზინგი?</h1>
    <h6>ივლისი 2018</h6>
    <br />
    <h1 style="text-align: center">„სიმდიდრე სარგებლობაშია და არა საკუთრებაში“  - არისტოტელე.</h1>
    <img src="../../../../assets/blog/leasing/img1.jpg" alt="" />

    <p>
      ანტიკური დრო, რომელიც ხშირად შორეულ წარსულად გვეჩვენება, ხანდახან ძალიან ახლობელი აღმოჩნდება ხოლმე. როცა ვუყურებთ
      ეგვიპტის უნიკალურ არქიტექტურულ ნაგებობებს, ვკითხულობთ ბერძნული სამოქალაქო წესრიგის შესახებ, ვხედავთ რომაული
      ქალაქების დაგეგმარებას, ვხდებით, რომ საზოგადოებრივი ცხოვრების ხერხემალი შეიძლება დიდად არც შეცვლილა და თითქმის
      იმავე „წესებს“ ეფუძნება. ადამიანები მაშინაც ფიქრობდნენ კარგ ცხოვრებაზე, ზრუნავდნენ საკუთარ თავზე, ყიდულობდნენ და
      ყიდდნენ. შესაბამისად, არც ის უნდა იყოს გასაკვირი, რომ ძველი წელთაღრიცხვით მეთვრამეტე საუკუნეში, ჯერ კიდევ
      ბაბილონის სამეფოში არსებობდა ლიზინგი.
    </p>
    <p>
      ხამურაბის დროინდელ ბაბილონში ლიზინგი ასეთი ფორმით მუშაობდა: თუ ჯარისკაცი გადაწყვეტდა, რომ არ სურდა მიწის
      დამუშავება, რომელიც სამეფოსგან ჯარში სამსახურის სანაცვლოდ მიიღო, მაშინ ის მიწას აბარებდა ეგრედწოდებულ „სალიზინგო
      კომპანიას“, რომელიც, თავის მხრივ, გარკვეული სისტემატიური შემოსავლის სანაცვლოდ დროებით გასცემდა მიწას.
    </p>
    <p>
      მაინც რა არის ლიზინგი? ვისთვისაც ამ სიტყვის შინაარსი უცნობია, ბაბილონური გამოცდილებიდან ადვილად გამოიტანს
      დასკვნას, რომ ლიზინგი მეტ ნაკლებად ჰგავს ქირას. უბრალოდ ამ შემთხვევაში გამქირავებლისა და დამქირავებლის ნაცვლად აქ
      სხვა პერსონაჟები - კომპანია და მისი მომხმარებლები არიან, რაც ოპერაციული თვალსაზრისით სრულიად ცვლის სურათს და
      ურთიერთობაში ახალი პრინციპები შემოაქვს. დამქირავებელს აღარ უწევს ცალკეულ გამქირავებლებლის ძებნა და შემდეგ მათთან
      შეხვედრა-მოლაპარაკებები. მას შეუძლია პირდაპირ მიმართოს სალიზინგო კომპანიას, რომელიც უკვე ფლობს მისთვის სასურველ
      უძრავ ქონებას, მოწყობილობასა თუ ტრანსპორტს, და გარკვეული ვადით გამოიყენოს პროდუქტი.
    </p>
    <img src="../../../../assets/blog/leasing/img2.jpg" alt="" />
    <p>
      ქირისგან განსხვავებით: სალიზინგო პერიოდის ხანგრძლივობა უფრო დიდია პირობების შესახებ შეთანხმება, რომელიც ლიზინგის
      დასაწყისში დაიდება, დოკუმენტირებულია და სალიზინგო პერიოდის არცერთ ეტაპზე არ იცვლება სალიზინგო პერიოდის ბოლოს,
      მომხმარებელს შეუძლია შეისყიდოს და საკუთრებაში დაიტოვოს ქონება. მართალია ლიზინგი ხამურაბის დროსაც არსებობდა, მაგრამ
      ბოლო პერიოდის განმავლობაში მისი როლი ეკონომიკაში ერთიორად გაიზარდა და ლიზინგმა განვითარებული ქვეყნების ეკონომიკურ
      ზრდაში მნიშვნელოვანი როლი დაიკავა. რა შეიძლება იყოს ამის მიზეზი? თუ სტატისტიკას გადავხედავთ, ვნახავთ რომ მსოფლიოში
      განსაკუთრებული პოპულარობით სარგებლობს 1. სხვადასხვა მოწყობილობებისა და აღჭურვილობების ლიზინგი 2. ავტო ლიზინგი.
    </p>
    <img src="../../../../assets/blog/leasing/img3.jpg" alt="" />
    <p>
      წარმოიდგინე, რომ შენ ხარ კლინიკის მფლობელი, რომელსაც მაღალი სტანდარტის გამოკვლევები აქვს. რადიოლოგიაში კი
      განსაკუთრებით მნიშვნელოვანია, გქონდეს სამედიცინო მოწყობილობები, რომლებიც ყველაზე ზუსტ სურათს აჩვენებს. მეორე
      მხრივ, ასეთი ტექნიკა საკმაოდ ძვირი ღირს და თანაც მწარმოებელი კომპანიების მხრიდან ხშირად განახლებადია. შენ კი
      ნამდვილად იცი, რომ სტანდარტის დასაკმაყოფილებლად აუცილებლად ახალი ტექნიკა გჭირდება. როგორ შეიძლება მოიქცე? ასეთ
      დროს კომპანიების უმეტესობა ლიზინგს მიმართავს, რაც ალბათ ყველაზე ლოგიკური და ხელსაყრელი გამოსავალია - იყენებ
      მოწყობილობას მისი ყიდვის გარეშე.
    </p>
    <p>
      მსგავსი შემთხვევების გარდა, არსებობს მთელი რიგი კომპანიებისა, რომლებიც კონკრეტულ ტექნიკას მხოლოდ გარკვეული
      პერიოდის განმავლობაში იყენებენ და სრულიადაც არ სჭირდებათ ამ ტექნიკის ფლობა. მაგალითად, ეს შეიძლება იყოს სამშენებლო
      კომპანია, რომელსაც კონკრეტული მექანიზმი მშენებლობის მხოლოდ გარკვეულ ეტაპზე სჭირდება და არა მუდმივად. გამოსავალი
      აქაც ხშირად ლიზინგია.
    </p>
    <img src="../../../../assets/blog/leasing/img4.jpg" alt="" />
    <p>
      ბოლო დროს განსაკუთრებულად ტენდენციური გახდა ავტო ლიზინგი. მის პოპულარობას კი, როგორც წესი, ერთი მარტივი ჰიპოთეზით
      ხსნიან. ავტომანქანა არის პროდუქტი, რომელსაც მცირე დროის (რამდენიმე წლის) განმავლობაში მკვეთრად უმცირდება
      ღირებულება. მარტივად რომ ავხსნათ, შეუძლებელია, მოხმარების შემდეგ მანქანა იგივე ფასად გაყიდო, რა ფასადაც იყიდე.
      მეტიც, ამ ორ ფასს შორის სხვაობა ხშირად არც თუ ისე პატარაა. თანაც, ერთი ადამიანის მიერ მანქანის გამოცვლის
      მაჩვენებელი საკმაოდ მაღალია. შესაბამისად, ბუნებრივია, საზოგადოების ნაწილი ყიდვას ლიზინგს ამჯობინებს. ავტომობილის
      ლიზინგი კი კარგი მაგალითია იმისთვის, რომ ლიზინგის კიდევ ერთი მახასიათებელი ავხსნათ - დაზღვევა. თუ მანქანის ყიდვის
      შემდეგ, მის დაზღვევაზე შენ უნდა იზრუნო, ლიზინგის დროს ის უკვე დაზღვეულია კომპანიის მხრიდან და დაზიანების
      შემთხვევაში შენ აღარ მოგიწევს ფულის დახარჯვა მის შესაკეთებლად. ეს ხშირ შემთხვევაში გადამწყვეტი ფაქტორია, როცა
      არჩევანი ლიზინგზე დგება.
    </p>
    <img src="../../../../assets/blog/leasing/img5.jpg" alt="" />
    <p>
      საბოლოო ჯამში, ადამიანების უფრო და უფრო დიდი ნაწილი არისტოტელეს ზემოხსენებულ იდეას საკუთარ ქცევაში თარგმნის და
      ფიქრობს, რომ „სიმდიდრე სარგებლობაშია და არა საკუთრებაში“.
      <br />
      <br />
      <strong>ავტორი: მარიამ კოპალეიშვილი</strong>
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item ">
    <h1>What is Leasing?</h1>
    <h6>July 2018</h6>
    <br />
    <h1 style="text-align: center">„Wealth is in use, not in ownership.“  - Aristotle.</h1>
    <img src="../../../../assets/blog/leasing/img1.jpg" alt="" />

    <p>
      The ancient times, which often seem like a distant past, sometimes appear surprisingly close. When we observe the
      unique architectural structures of Egypt, read about Greek civil order, or study the planning of Roman cities, we
      realize that the backbone of social life may not have changed much, and it is based on almost the same "rules."
      Even then, people thought about a good life, cared for themselves, and bought and sold. Therefore, it should not
      be surprising that leasing existed as early as the 18th century B.C. in Babylon.
    </p>
    <p>
      In the time of Hammurabi, leasing in Babylon worked in the following way: If a soldier decided he no longer wanted
      to cultivate the land he had received from the kingdom in exchange for his military service, he would lease the
      land to a so-called "leasing company," which would, in turn, lease the land to someone else for a regular income.
    </p>
    <p>
      So, what exactly is leasing? For those who may not be familiar with the term, based on the Babylonian experience,
      one could easily conclude that leasing is quite similar to renting. The difference is that, in this case, instead
      of individual landlords and tenants, there are companies and their customers, which operationally changes the
      dynamics and introduces new principles into the relationship. The tenant no longer has to search for separate
      landlords and negotiate with them. They can directly contact a leasing company that already owns the property,
      equipment, or transportation they need and use it for a set period.
    </p>
    <img src="../../../../assets/blog/leasing/img2.jpg" alt="" />
    <p>
      Unlike renting, the leasing period is longer, and the terms agreed upon at the start of the lease are documented
      and do not change at any stage during the lease. At the end of the leasing period, the customer has the option to
      purchase and retain the property. While leasing existed in Hammurabi's time, in recent years, its role in the
      economy has increased significantly, and leasing has become an essential part of the economic growth in developed
      countries. What could be the reason for this? If we look at the statistics, we see that leasing is particularly
      popular worldwide in two areas: leasing of equipment and machinery and auto leasing.
    </p>
    <img src="../../../../assets/blog/leasing/img3.jpg" alt="" />
    <p>
      Imagine you are the owner of a clinic with high-standard diagnostic equipment. In radiology, it is especially
      important to have the most precise equipment available. On the other hand, such equipment is very expensive and
      frequently updated by manufacturers. You know that in order to meet the standard, you need the latest technology.
      What should you do? In this situation, most companies opt for leasing, as it is the most logical and convenient
      solution — you get to use the equipment without having to buy it.
    </p>
    <p>
      Besides such cases, there are many companies that need specific equipment for only a limited time and do not need
      to own it permanently. For example, a construction company may need a particular machine only for a certain stage
      of construction and not on a long-term basis. Leasing often provides the perfect solution here as well.
    </p>
    <img src="../../../../assets/blog/leasing/img4.jpg" alt="" />
    <p>
      Recently, auto leasing has become particularly popular. The reason for this is usually explained by one simple
      hypothesis: A car is a product whose value sharply decreases over a short period of time (a few years). To put it
      simply, it is impossible to sell a car for the same price you bought it for. Moreover, the difference between
      these two prices is often quite significant. Additionally, the rate at which people replace their vehicles is
      relatively high. Therefore, it is natural that some people prefer leasing over buying. Auto leasing is a great
      example of another feature of leasing — insurance. After purchasing a car, the owner is responsible for insuring
      it, but with leasing, the car is already insured by the leasing company. In case of damage, the customer does not
      have to spend money on repairs. This is often a decisive factor when the choice between buying and leasing is
      made.
    </p>
    <img src="../../../../assets/blog/leasing/img5.jpg" alt="" />
    <p>
      In the end, more and more people are translating Aristotle’s idea into their behavior, thinking that "wealth is in
      use, not in ownership."
      <br />
      <br />
      <strong>Author: Mariam Kopaleishvili</strong>
    </p>
  </div>
</ng-container>
